import React from "react";
import { getSignInPath, isSignedIn } from "../../utils/util";
import { t } from "i18next";
import CourseBottomNavigation from "./QuizBottomNavigation";
import QuizProgressBar from "./QuizProgressBar";

function QuizHome({
  isKnoledgeCheck,
  linkPrefix,
  isEnrolled, 
  courseId,
  completedAssetIds,
  setFirstQuestion,
  currentQuizzId,
  userEnrollmentId,
  nextLesson,
  prevLesson,
  questions,
  handleRegisterUserAndUpdateEnrollment
}) {
  return (
    <>
      <QuizProgressBar active={-1} questions={questions} progress={0} />

      <div className="home-quiz">
        <div className="text-home-quiz">
          <p>
            {!isKnoledgeCheck
              ? `${t("quiz-home-message")}`
              : `${t("quiz-home-message-ck")}`}
          </p>
        </div>
        {!isSignedIn() ? (
          <div className="button-bottom-home button-bottom-home-unassigned">
            <div>
              <a href={getSignInPath()}>{t("sign-in")}</a>{" "}
              {t("quiz-sign-in-text")}
            </div>
            <button onClick={() => setFirstQuestion(true)}>
              {t("start-test")}
            </button>
          </div>
        ) : (
          <div className="button-bottom-home">
            <button onClick={() => handleRegisterUserAndUpdateEnrollment()}>
              {t("start-test")}
            </button>
          </div>
        )}
      </div>

      {isKnoledgeCheck && (
        <CourseBottomNavigation
          isEnrolled={isEnrolled}
          courseId={courseId}
          currentQuizzId={currentQuizzId}
          completedAssetIds={completedAssetIds}
          linkPrefix={linkPrefix}
          userEnrollmentId={userEnrollmentId}
          nextLesson={nextLesson}
          prevLesson={prevLesson}
        />
      )}
    </>
  );
}

export default QuizHome;
